import angular from 'angular';

import { ModalCriarNovoPedidoController, ModalCriarNovoPedidoController2 } from './modal-criar-novo-pedido/modal-criar-novo-pedido.controller';

export const ModalModule = "mandaeApp.modal";

angular.module(ModalModule, [])
  .controller('ModalCriarNovoPedidoController', ModalCriarNovoPedidoController)
  .controller('ModalCriarNovoPedidoController2', ModalCriarNovoPedidoController2)
